export const FINISH_CLIPBOARD_COMMAND = 'FINISH_CLIPBOARD_COMMAND';
export const PASTE_CLIPBOARD_CONTENT = 'PASTE_CLIPBOARD_CONTENT';
export const SET_CLIPBOARD = 'SET_CLIPBOARD';
export const START_CLIPBOARD_COMMAND = 'START_CLIPBOARD_COMMAND';
